<div class="row offer-detail__row">
  <div class="col-12 col-md-8 offer-detail__main">
    <mat-stepper appMatVerticalStepperScroller [linear]="true" #stepper [orientation]="stepperOrientation()"
                 labelPosition="bottom" (selectionChange)="stepperSelectionChanged($event)"
                 class="offer-detail__stepper">
      <!-- Upselling -->
      <!--           Mit @if (false && ..." ist der Block deaktiviert und bringt somit eine Warnung-->
      <!--          @if (false && offer().combinedOfferList) {-->
      <!--            <mat-step [editable]="isEditable"-->
      <!--                      class="offer-detail__step offer-detail__step&#45;&#45;upselling">-->
      <!--              <ng-template matStepLabel>-->
      <!--                <div [innerHTML]="translationService.getTranslation('step_upselling')"-->
      <!--                     class="offer-detail__step-label offer-detail__step-label&#45;&#45;upselling"></div>-->
      <!--              </ng-template>-->

      <!--              <app-upselling-step-->
      <!--                [offer]="offer()"></app-upselling-step>-->
      <!--            </mat-step>-->
      <!--          }&ndash;&gt;-->

      <!-- Registrierung (opt.) oder Anmeldung, falls Anmeldedaten schon existieren -->
      @if (!isAuthenticated() && !hideLoginBox()) {
        <mat-step #registrationStep [state]="stepIndicatorState(registrationStep, stepper)"
                  [editable]="isEditable()" class="offer-detail__step offer-detail__step--register"
                  [completed]="registrationStepCompleted()">
          <ng-template matStepLabel>
            <div [innerHTML]="translationService.getTranslation('step_orderRegister')"
                 class="offer-detail__step-label offer-detail__step-label--register"></div>
          </ng-template>
          <app-registration-step
            [parentStepper]="stepper"
            [isAuthenticated]="isAuthenticated()"
            [hideLoginBox]="hideLoginBox()"
            [isEditable]="isEditable()"
            (stepReady)="onRegistrationStepCompleted($event)">
          </app-registration-step>
        </mat-step>
      }

      <!-- Adressen -->
      @if (offer() && addressCombination() != AddressCombination.NONE) {
        <mat-step #addressStep [state]="stepIndicatorState(addressStep, stepper)"
                  class="offer-detail__step offer-detail__step--address"
                  [completed]="addressStepCompleted() && stepReached(addressStep, stepper)">
          <ng-template matStepLabel>
            <div [innerHTML]="translationService.getTranslation('step_orderAddr')"
                 class="offer-detail__step-label offer-detail__step-label--address"></div>
          </ng-template>
          <app-address-step
            [isEditable]="isEditable()"
            [hideLoginBox]="hideLoginBox()"
            [isWinBack]="isWinback()"
            [offer]="offer()"
            [currentProductAlreadyOrdered]="currentProductAlreadyOrdered()"
            [parentStepper]="stepper"
            [addressCombination]="addressCombination()"
            (stepCompleted)="onAddressStepCompleted($event)">
          </app-address-step>
        </mat-step>
      }

      <!-- Prämien (opt.)-->
      @if (offer() && offer().bonusList.length > 0) {
        <mat-step #bonusStep [state]="stepIndicatorState(bonusStep, stepper)"
                  [editable]="isEditable()"
                  class="offer-detail__step offer-detail__step--bonus"
                  [completed]="bonusStepCompleted() && stepReached(bonusStep, stepper)">
          <ng-template matStepLabel>
            <div [innerHTML]="translationService.getTranslation('step_orderBonus')"
                 class="offer-detail__step-label offer-detail__step-label--bonus"></div>
          </ng-template>
          <app-bonus-step
            [parentStepper]="stepper"
            [isAuthenticated]="isAuthenticated()"
            [offer]="offer()"
            [bonuses]="offer().bonusList"
            (stepCompleted)="onBonusStepCompleted($event)">
          </app-bonus-step>
        </mat-step>
      }

      <!-- Zahlungsmodalitäten -->
      <mat-step #paymentStep [state]="stepIndicatorState(paymentStep, stepper)"
                [editable]="isEditable()" class="offer-detail__step offer-detail__step--payment"
                [completed]="paymentStepCompleted() && stepReached(paymentStep, stepper)">
        <ng-template matStepLabel>
          <div [innerHTML]="translationService.getTranslation('step_orderPayment')"
               class="offer-detail__step-label offer-detail__step-label--payment"></div>
        </ng-template>
        <app-payment-step
          [currentProductAlreadyOrdered]="currentProductAlreadyOrdered()"
          [offer]="offer()"
          [parentStepper]="stepper"
          [userData]="userData()"
          (readyState)="onPaymentStepCompleted($event)"
          (onlinePaymentSelected)="onOnlinePaymentSelected($event)">
        </app-payment-step>
      </mat-step>

      <!-- Preisberechnung / Zusammenfassung -->
      <mat-step #summaryStep [state]="stepIndicatorState(summaryStep, stepper)"
                class="offer-detail__step offer-detail__step--price">
        <ng-template matStepLabel>
          <div [innerHTML]="translationService.getTranslation('step_summary')"
               class="offer-detail__step-label offer-detail__step-label--price"></div>
        </ng-template>
        <app-summary-step
          [stepper]="stepper"
          [offer]="offer()"
          [userData]="userData()"
          [showOnlinePayment]="onlinePaymentSelected()">
        </app-summary-step>
      </mat-step>
    </mat-stepper>
  </div>

  <!-- Bestellzusammenfassung und Bestellabschluss -->
  <div [className]="'col-12 col-md-4 offer-detail__side'">
    <app-offer-card
      [offer]="offer()"
      [showOnOfferPage]="false"
      [stepper]="stepper"
      [deliveryAddress]="selectedDeliveryAddress"
      [billingAddress]="selectedBillingAddress"
      [bonusAddress]="selectedBonusAddress"
      [paymentCode]="selectedFormOfPayment"
      [paymentFrequency]="selectedPaymentFrequency"
      [startDate]="selectedStartDate"
      [prices]="offerPrice"
      [creatingOrder]="creatingOrder"
      [onlinePayment]="true"
      (save)="onCompleteOrder($event)"
      (optInsSelected)="onOptInsSelected($event)"
      class="offer-detail__side-card">
    </app-offer-card>
  </div>
</div>
